<script setup lang="ts">
import useWordOfTheDayStore from '../store';
import { storeToRefs } from 'pinia';
import Flower from './Flower.vue';
import { useDisplay } from 'vuetify';

const store = useWordOfTheDayStore();
const { keywordOfTheDay } = storeToRefs(store);

const sendGameStartEvent = () => {
  store.sendGameStartEvent();
};

const start = () => {
  sendGameStartEvent();
  store.setGameState('game');
};

const { lgAndUp } = useDisplay();
</script>

<template>
  <div class="the-game">
    <h1 class="title mt-10">Dagens ord</h1>
    <Flower class="py-10" />
    <v-btn
      v-if="keywordOfTheDay"
      variant="outlined"
      color="white"
      @click="start"
      prepend-icon="mdi-flag-checkered"
      class="action-btn"
      :height="lgAndUp ? '56px' : '48px'"
      >Börja spela
    </v-btn>
    <v-progress-circular v-else indeterminate size="64"></v-progress-circular>
  </div>
</template>

<style scoped lang="scss">
.the-game {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  color: #fff;
}

.title {
  transform-origin: top left;
  font-size: 3rem;
  font-weight: bold;
  font-family: 'Chalkduster', sans-serif;
  color: #fff;
}

:deep(.radio-group) {
  label {
    font-family: 'Comic Sans MS', sans-serif;
    font-size: 1.2rem;
  }
}
</style>
